<template>
  <floating-window name="object" left="300" top="100" defaultVisible="true">
    <div class  ="object-ui">
      <el-tabs>
        <el-tab-pane label=icon>
          <icon-picker @picked ="iconPicker_pickedHandler" />
        </el-tab-pane>
        <el-tab-pane label=card>
          <card-generator />
        </el-tab-pane>
      </el-tabs>
      <button @click="clearObjects">clear objects</button>
    </div>
  </floating-window>
</template>

<script>
import IconPicker    from './icon-picker'
import CardGenerator from './card-generator'

import { mapActions } from 'vuex'

export default {
  name: 'ObjectUi',
  data () {
    return {}
  },
  methods: {
    iconPicker_pickedHandler (icon) {
      this.$eventHub.$emit('object-pick', icon)
    },
    ...mapActions('object', [
      'clearObjects'
    ])
  },
  components: {
    IconPicker,
    CardGenerator
  }
}
</script>

<style scoped>
.object-ui {
  width       : 300px;
  user-select : none;
  padding     : 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/object/controller/index.vue